import { label } from '../../shared/redux';
import { Action } from '@ngrx/store';

export const publicActionTypes = {
  SetPrivateLabelHeaderLogo: label('[public] SET Private Label Logo')
};


export class SetPrivateLabelLogoAction implements Action {
  readonly type = publicActionTypes.SetPrivateLabelHeaderLogo;
  constructor(public payload: string) {}
}

export type Actions = SetPrivateLabelLogoAction
    ;
